import log from "loglevel";

export const logger = log;
